import path from 'path';

export const WEBVIEW_BASE_PATH = path.join(__dirname, '../webviews/');
